import React, { useEffect, useState } from 'react';
import { Pagination } from 'antd';
import { RealtimeSettlementOrderDailySumFilterInitialValue } from './config/filterOptions';
import { RealtimeSettlementOrderDailySumColumns } from "./components/RealtimeSettlementOrderDailySumColumns";
import { useRealtimeSettlementOrderDailySumQuery } from "./hooks/useRealtimeSettlementOrderDailySumQuery";
import RealtimeSettlementOrderDailySumFilter from "./components/RealtimeSettlementOrderDailySumFilter";

const RealtimeSettlementOrderDailySumPage: React.FC<{ sumType?: number }> = ({ sumType }) => {

    const [tempFilters, setTempFilters] = useState(RealtimeSettlementOrderDailySumFilterInitialValue());
    const [filters, setFilters] = useState(RealtimeSettlementOrderDailySumFilterInitialValue());
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    // 使用自定义hook获取数据
    const {
        realtimeSettlementOrderDailySumData,
        loading,
        refetch,
        totalElements,
        buildQueryVariables
    } = useRealtimeSettlementOrderDailySumQuery(filters, currentPage, pageSize, sumType);

    const handleResetFilters = () => {
        setTempFilters(RealtimeSettlementOrderDailySumFilterInitialValue());
        setFilters(RealtimeSettlementOrderDailySumFilterInitialValue());
    };

    const handleFilter = () => {
        setFilters(tempFilters);
        setCurrentPage(1);
    };

    // 添加useEffect监听状态变化后执行查询
    useEffect(() => {
        refetch(buildQueryVariables());
    }, [filters, currentPage, pageSize]);

    // 处理分页变化
    const handlePageChange = (page: number, pageSize: number) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    return (
        <div className="bg-white rounded-lg shadow-sm p-6">
            {/* 筛选条件 */}
            <RealtimeSettlementOrderDailySumFilter
                filters={tempFilters}
                setFilters={setTempFilters}
                handleFilter={handleFilter}
                handleResetFilters={handleResetFilters}
            />

            {/* 数据列表 */}
            <RealtimeSettlementOrderDailySumColumns
                rowData={realtimeSettlementOrderDailySumData}
                loading={loading}
                filters={filters}
            />

            {/* 分页 */}
            <div className="flex justify-between items-center">
                <div className="text-gray-500">{totalElements} results</div>
                <Pagination
                    current={currentPage}
                    total={totalElements}
                    pageSize={pageSize}
                    size="small"
                    showSizeChanger
                    onChange={handlePageChange}
                />
            </div>
        </div>
    );
};

export default RealtimeSettlementOrderDailySumPage;
